export interface RelationshipState {
  allRelationships: any[];
  allInvites: any[];
  impersonateUserId: any;
  allClientGroups: any[];
  impersonateUserIdForReport: any;
  impersonateUserListForReport: any[];
  allRelationshipListLoading: boolean;
  MySuggestions:any[]
}

export const initialState: RelationshipState = {
  allRelationships: null,
  allInvites: null,
  impersonateUserId: null,
  allClientGroups: null,
  impersonateUserIdForReport: null,
  impersonateUserListForReport: null,
  allRelationshipListLoading: false,
  MySuggestions:[]
};
